import type { SnapshotOf } from '../../store/duel'
import { JoinSheet } from '../JoinSheet'
import { MenuSheet } from '../MenuSheet'
import type { DuelGameDef } from './defs'

/** The Join and Menu sheets a duel's phone bar opens, wired to that game's paths. */
export function DuelSheets<Snap extends SnapshotOf<S>, S extends { turnSeconds: number }>({
  def,
  sheet,
  onClose,
  joinId,
}: {
  def: DuelGameDef<Snap, S>
  sheet: string | null
  onClose: () => void
  joinId: string
}) {
  return (
    <>
      <JoinSheet open={sheet === 'join'} onClose={onClose} id={joinId} path={def.roomPath} />
      <MenuSheet open={sheet === 'menu'} onClose={onClose} current={def.home} />
    </>
  )
}
